export default "__VITE_ASSET__sRLRxgzW__"